import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

export const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100vh',
        height: 'auto',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 40px 56px',
        color: 'white',
        overflowY: 'auto'
      }}
    >
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px'
      }}>
        <h1 style={{
          fontSize: '56px',
          fontWeight: 'bold',
          textAlign: 'center',
          margin: 0,
          marginBottom: '16px',
          letterSpacing: '-1px'
        }}>
          The Contact Game
        </h1>
        <p style={{
          fontSize: '20px',
          opacity: 0.9,
          margin: 0,
          marginBottom: '12px'
        }}>
          Online Word Chain Party Game
        </p>

        <button
          onClick={() => navigate('/game')}
          style={{
            padding: '20px 60px',
            fontSize: '24px',
            fontWeight: 'bold',
            borderRadius: '16px',
            border: 'none',
            background: 'rgba(255, 255, 255, 0.9)',
            color: '#667eea',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'white';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          Play Game
        </button>

        <section
          style={{
            marginTop: '36px',
            maxWidth: '860px',
            width: '100%',
            background: 'rgba(15, 23, 42, 0.35)',
            border: '1px solid rgba(255, 255, 255, 0.18)',
            borderRadius: '20px',
            padding: '22px 24px',
            boxShadow: '0 18px 40px rgba(15, 23, 42, 0.35)',
            backdropFilter: 'blur(6px)'
          }}
        >
          <h2 style={{
            margin: '0 0 12px',
            fontSize: 'clamp(20px, 2.4vw, 32px)'
          }}>
            The Ultimate Contact Word Game for Parties
          </h2>
          <p style={{
            margin: '0 0 12px',
            fontSize: 'clamp(14px, 1.4vw, 18px)',
            lineHeight: 1.6,
            color: 'rgba(248, 250, 252, 0.92)'
          }}>
            Play the Contact Game online for free with friends and family. This fast-paced word chain party game challenges your vocabulary, creativity, and quick thinking. Perfect for house parties, game nights, road trips, college hangouts, and team bonding sessions, this classic word guessing game keeps everyone engaged.
          </p>
          <p style={{
            margin: '0 0 16px',
            fontSize: 'clamp(14px, 1.4vw, 18px)',
            lineHeight: 1.6,
            color: 'rgba(248, 250, 252, 0.92)'
          }}>
            If you enjoy word games like charades, taboo, or word association games, you'll
            love Contact.
          </p>
          <h3 style={{
            margin: '0 0 10px',
            fontSize: 'clamp(16px, 1.8vw, 22px)'
          }}>
            How to Play Contact
          </h3>
          <ol style={{
            margin: '0 0 12px',
            paddingLeft: '18px',
            fontSize: 'clamp(14px, 1.4vw, 18px)',
            lineHeight: 1.6,
            color: 'rgba(248, 250, 252, 0.92)'
          }}>
            <li>One player thinks of a secret word.</li>
            <li>The host reveals the first letter.</li>
            <li>Other players give clues to guess matching words.</li>
            <li>When two players think of the same word, they say "Contact!"</li>
            <li>Count down together - if the host can't guess it, a new letter is revealed.</li>
            <li>The game continues until the secret word is solved.</li>
          </ol>
          <p style={{
            margin: 0,
            fontSize: 'clamp(14px, 1.4vw, 18px)',
            lineHeight: 1.6,
            color: 'rgba(248, 250, 252, 0.92)'
          }}>
            Simple rules. Endless chaos. Maximum fun.
          </p>
        </section>
      </div>

      <footer style={{
        marginTop: '40px',
        fontSize: '14px',
        opacity: 0.7,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px'
      }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px'
          }}
        >
          <Link
            to="/support"
            style={{
              color: 'white',
              textDecoration: 'underline'
            }}
          >
            Support
          </Link>
          <Link
            to="/privacy"
            style={{
              color: 'white',
              textDecoration: 'underline'
            }}
          >
            Privacy Policy
          </Link>
        </div>
        <a
          href="https://www.linkedin.com/in/akshaya-kumar-t/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'white',
            textDecoration: 'underline'
          }}
        >
          Built by Akshaya Kumar T
        </a>
      </footer>
    </div>
  );
};
